import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { SharedModule } from '../_shared/shared.module';
import { AgentLoSignupRoutingModule } from './agent-lo-signup-routing.module';
import { AgentLoSignupComponent } from './component/agent-lo-signup/agent-lo-signup.component';

export const options: Partial<IConfig> = {
  thousandSeparator: ',',
};

@NgModule({
  declarations: [AgentLoSignupComponent],
  imports: [
    CommonModule,
    AgentLoSignupRoutingModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCardModule,
    SharedModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatChipsModule,
    MatAutocompleteModule,
    NgxMaskModule.forRoot(options),
  ],
})
export class AgentLoSignupModule {}
